class More {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    if($(".js-item-list li").length <= 8) {
      $(".js-more").css({"display": "none"});
    } else {
      $(this.el).on({
        click: function() {
          $(".js-item-list li:nth-of-type(n + 9)").css({'display': 'block'})
          $(this).css({'display': 'none'})
          return false;
        }
      })
    }
  }
}